import { createFeatureSelector, createSelector } from '@ngrx/store';
import { complianceFeatureKey } from 'src/app/compliance/store/selectors';
import { ComplianceState } from 'src/app/compliance/store/state/compliance.state';

export const complianceFeature = createFeatureSelector<ComplianceState>(complianceFeatureKey);

export const selectFacility = createSelector(complianceFeature, (state) => state.facilities.facility);

export const selectFacilities = createSelector(complianceFeature, (state) => state.facilities.facilities);

export const selectFilter = createSelector(complianceFeature, (state) => state.facilities.filter);

export const selectFacilityClientPortalVisibilitySettings = createSelector(
    complianceFeature,
    (state) => state.facilities?.clientPortalVisibilitySettings
);

export const selectDocDueDates = createSelector(complianceFeature, (state) => state.facilities?.docDueDates);

export const selectBrands = createSelector(complianceFeature, (state) => state.facilities.brands);

export const selectVmsLookups = createSelector(complianceFeature, (state) => state.facilities.vmsLookups);

export const selectFacilityAutomatchSettings = createSelector(
    complianceFeature,
    (state) => state.facilities.automatchSettings
);
